import { render, staticRenderFns } from "./DialogCreateTask.vue?vue&type=template&id=d66c8e3c&scoped=true"
import script from "./DialogCreateTask.vue?vue&type=script&lang=js"
export * from "./DialogCreateTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66c8e3c",
  null
  
)

export default component.exports